// ── SupportModal — Plattform-Auswahl, im Marken-Pop-up (BrandModal) ─────
// Öffnet das E-Mail-Programm mit vorbefülltem [App]/[Web]-Tag, damit die
// Anfrage direkt richtig zugeordnet wird.

import { Icons } from './red/Icons';
import { useT } from '../i18n/useT';
import BrandModal, { ChoiceGrid, ChoiceTile } from './red/BrandModal';
import { buildDiagnostics, downloadDiagnostics } from '../utils/supportDiagnostics';

const SUPPORT_EMAIL = 'support@redcrypto.de';

function buildMailto(platform, t, summary, fileName) {
  const tag = platform === 'mobile' ? '[App]' : '[Web]';
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const subject = `${tag} ${t('mod_support_mail_subject')}`;
  const body = [
    t('mod_support_mail_desc'),
    '',
    '',
    '---',
    `${t('mod_support_mail_platform')}: ${platform === 'mobile' ? t('mod_support_mail_platform_app') : t('mod_support_mail_platform_web')}`,
  ];
  // Triage-Zahlen direkt in den Text — auch falls der Anhang vergessen wird.
  if (summary) {
    body.push(
      `${t('mod_support_mail_tx')}: ${summary.txCount}`,
      `${t('mod_support_mail_origin')}: ${summary.origin}`,
      `${t('mod_support_mail_version')}: ${summary.bundleId}`,
      `${t('mod_support_mail_plan')}: ${summary.tier}`,
      `${summary.lang} / ${summary.currency}`,
    );
  }
  body.push(`User-Agent: ${ua}`);
  // Anhang-Aufforderung ans Ende, gut sichtbar.
  if (fileName) {
    body.push('', t('mod_support_mail_attach').replace('{file}', fileName));
  }
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body.join('\n'))}`;
}

// Glyphs als JSX-Pfade (kompatibel mit ChoiceTile, das ein <svg> rendert).
const PHONE_GLYPH = Icons.phone;
const DESKTOP_GLYPH = Icons.desktop;

export default function SupportModal({ open, onClose, txs = [], tier = null }) {
  const { t } = useT();
  const choose = (platform) => {
    try {
      // Diagnose-Paket bauen + herunterladen, Triage-Zahlen in die Mail packen.
      const { payload, summary } = buildDiagnostics({ txs, tier, platform });
      const fileName = downloadDiagnostics(payload);
      window.location.href = buildMailto(platform, t, summary, fileName);
    } catch {
      // Fallback: Mail trotzdem öffnen, nur ohne Diagnose-Anhang.
      try {
        window.location.href = buildMailto(platform, t);
      } catch {}
    }
    onClose?.();
  };

  return (
    <BrandModal
      open={open}
      onClose={onClose}
      eyebrow={t('support')}
      title={t('mod_support_title')}
      subtitle={t('mod_support_sub')}
      footer={<>{t('mod_support_footer_pre')} <span style={{ fontWeight: 700 }}>{SUPPORT_EMAIL}</span></>}
    >
      <ChoiceGrid>
        <ChoiceTile
          glyph={PHONE_GLYPH}
          label={t('mod_support_app')}
          sub={t('mod_support_app_sub')}
          onClick={() => choose('mobile')}
        />
        <ChoiceTile
          glyph={DESKTOP_GLYPH}
          label={t('mod_support_pc')}
          sub={t('mod_support_pc_sub')}
          onClick={() => choose('desktop')}
        />
      </ChoiceGrid>
    </BrandModal>
  );
}
